import { apiFetch } from './client';

export default async function http(
  path,
  {
    method = "GET",
    headers,
    body,
    responseType = "json", // "json" | "text"
    signal
  } = {}
) {
  return apiFetch(path, {
    method,
    headers,
    body,
    responseType,
    signal,
  });
}
